import axios from 'axios';
import { i18n } from 'vue-lang-router';
import router from '../../router';
import authHeader from '../../services/auth.header';

const authKey = 'AJFowi834sAAirutASfjOY';
const authApiUrl = process.env.VUE_APP_API_AUTH_URL;

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export default {
  state: {
    ...initialState,
    profile: null,
    profileLoading: false,
  },
  getters: {
    user: (state) => state.user,
    profile: (state) => state.profile,
    profileLoading: (state) => state.profileLoading,
  },
  mutations: {
    loginSuccess: (state, payload) => {
      state.status.loggedIn = true;
      state.user = payload.userObj;
    },
    loginFailure: (state) => {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout: (state) => {
      state.status.loggedIn = false;
      state.user = null;
      state.profile = null;
    },
    getUserProfile: (state) => {
      state.profileLoading = true;
    },
    getUserProfileSuccess: (state, payload) => {
      state.profile = payload;
      state.profileLoading = false;
    },
    getUserProfileFailure: (state) => {
      state.profile = null;
      state.profileLoading = false;
    },
    updateUserProfileSuccess: (state, payload) => {
      state.profile.first_name = payload.first_name;
      state.profile.last_name = payload.last_name;
      if (payload.acf.avatar) {
        state.profile.avatar = payload.acf.avatar.sizes.thumbnail;
      }
    },
  },
  actions: {
    REGISTER: ({}, payload) => {
      const params = {
        AUTH_KEY: authKey,
        user_login: payload.username,
        email: payload.email,
        first_name: payload.firstName,
        last_name: payload.lastName,
        password: payload.password,
        user_meta: `{"user_type":"${payload.userType}","user_locale":"${payload.locale}"}`,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${authApiUrl}/users`, {
            ...params,
          })
          .then(() => {
            resolve();
          })
          .catch(({ response }) => {
            let errorMessage = '';
            if (response.data.data.errorCode === 38) {
              errorMessage = i18n.t('auth.userExists');
            } else {
              errorMessage = i18n.t('common.connectionError');
            }
            reject(errorMessage);
          });
      });
    },
    LOGIN: ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`${authApiUrl}/auth`, {
            ...payload,
          })
          .then(({ data }) => {
            dispatch('VALIDATE_TOKEN', data.data.jwt).then(({ jwt, user }) => {
              const userObj = {
                ...user,
                jwt: jwt[0],
              };
              localStorage.setItem('user', JSON.stringify(userObj));
              commit('loginSuccess', { userObj });
            }).catch(() => {
              commit('loginFailure');
            });
            resolve();
          })
          .catch(({ response }) => {
            let errorMessage = '';
            if (response.data.data.errorCode === 48) {
              errorMessage = 'Wrong user credentials.';
            } else {
              errorMessage = i18n.t('common.connectionError');
            }
            reject(errorMessage);
          });
      });
    },
    VALIDATE_TOKEN: ({}, payload) => {
      const headers = {
        Authorization: `Bearer ${payload}`,
      };
      return new Promise((resolve, reject) => {
        axios
          .get(`${authApiUrl}/auth/validate`, { headers })
          .then(({ data }) => {
            resolve(data.data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    LOGOUT: ({ commit }) => {
      localStorage.removeItem('user');
      commit('logout');
    },
    GET_USER_PROFILE: ({ commit, dispatch }) => {
      commit('getUserProfile');
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_API_SUPPORT_URL}/profile`, { headers: authHeader() })
          .then(({ data }) => {
            commit('getUserProfileSuccess', data);
            resolve(data);
          })
          .catch(({ response }) => {
            // TODO: handle this globally
            if (response.data.data.errorCode === 14) {
              dispatch('LOGOUT');
              router.push('/login?session_expired=1');
            }
            commit('getUserProfileFailure');
            reject();
          });
      });
    },
    UPDATE_USER_PROFILE: ({ state, commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        axios.patch(`${process.env.VUE_APP_API_URL}/users/${state.profile.id}`, { ...payload }, { headers: authHeader() })
          .then(({ data }) => {
            commit('updateUserProfileSuccess', data);
            resolve(data);
          })
          .catch(({ response }) => {
            if (response.data.data.errorCode === 14) {
              dispatch('LOGOUT');
              router.push('/login?session_expired=1');
            }
            reject();
          });
      });
    },
    SEND_RESET_PASSWORD: ({}, payload) => {
      return new Promise((resolve, reject) => {
        axios.post(`${authApiUrl}/user/reset_password`, { email: payload.email })
          .then(() => {
            resolve();
          })
          .catch(({ response }) => {
            let errorMessage = '';
            if (response.data.data.errorCode === 64) {
              errorMessage = i18n.t('auth.userWithEmailNotExists');
            } else {
              errorMessage = i18n.t('common.connectionError');
            }
            reject(errorMessage);
          });
      });
    },
    RESET_PASSWORD: ({}, payload) => {
      return new Promise((resolve, reject) => {
        axios.put(`${authApiUrl}/user/reset_password`, { ...payload })
          .then(() => {
            resolve();
          })
          .catch(({ response }) => {
            let errorMessage = '';
            if (response.data.data.errorCode === 62) {
              errorMessage = i18n.t('auth.invalidPasswordResetKey');
            }
            reject(errorMessage);
          });
      });
    },
    DELETE_USER_ACCOUNT: () => {
      const params = {
        AUTH_KEY: authKey,
      };
      return new Promise((resolve, reject) => {
        axios.delete(`${authApiUrl}/users`, {
          headers: authHeader(),
          data: { ...params },
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            const errorMessage = i18n.t('common.connectionError');
            reject(errorMessage);
          });
      });
    },
  },
  namespaced: true,
};
